import React from "react"
import classnames from "classnames"
import styles from "./MyMazdaServiceHistory.less"
import { AccordionTextList } from "AtomicContainers"
import { Section, Content, H4, P, Space, Button, IdWrapper, Caption, ExternalLinkIcon, Interactive, A } from "AtomicComponents"

class MyMazdaServiceHistory extends React.Component {
  columns(date, distance, price, dealer, slug) {
    const { printAllLink } = this.props
    const viewButtonText = "View"
    return (
      <div className={classnames({
        [styles.MyMazdaServiceHistoryColumns]: true
      })}>
        <div><b>{date}</b></div>
        <div>{distance}</div>
        <div>{price}</div>
        <div>{dealer}</div>
        <div>
          {
            slug ?
              <A
                withoutStyle
                styleName="black"
                external
                href={printAllLink + "&slug=" + slug}
              >
                <ExternalLinkIcon
                  style={{
                    height: "11px",
                    width: "14px",
                    marginRight: "0.5em"
                  }} />
                <Caption>{viewButtonText}</Caption>
              </A>
              :
              "Print"
          }
        </div>
      </div>
    )
  }

  accordionTitle(service) {
    return (
      <IdWrapper key={service.slug} slug={service.slug}>
        <div className={classnames({
          [styles.MyMazdaServiceHistoryTitle]: true
        })}>
          <Interactive>
            <div>
              {this.columns(
                service.serviceDates,
                service.distance,
                service.formattedPrice,
                service.dealerName,
                service.slug
              )}
            </div>
          </Interactive>
        </div>
      </IdWrapper>
    )
  }

  render() {
    const { heading, blurb, emptyHistoryText, serviceHistoryData, printAllLink, printButtonText = "Print view" } = this.props

    return (
      <Section backgroundColor="#FFFFFF" padding>
        <H4 withDetails>{heading}</H4>
        <Space />
        <Content xmlString={blurb} textAlign="center" />
        <div className={classnames({
          [styles.MyMazdaServiceHistory]: true
        })}>
          <div className={classnames({
            [styles.MyMazdaServiceHistoryHeader]: true
          })}>
            <Interactive>
              {this.columns("DATE", "ODOMETER (KM)", "PRICE", "SERVICE LOCATION", null)}
            </Interactive>
          </div>
          {
            serviceHistoryData ?
              <AccordionTextList
                data={
                  serviceHistoryData.map((service, index) => {
                    return {
                      title: this.accordionTitle(service),
                      description: <div>
                        <div className={classnames({
                          [styles.MyMazdaServiceHistoryDetails]: true
                        })}>
                          <Interactive>ODOMETER (KM)</Interactive>
                          <P withoutMargin>{service.distance}</P>
                          <Space />
                          <Interactive>PRICE</Interactive>
                          <P withoutMargin>{service.formattedPrice}</P>
                          <Space />
                          <Interactive>SERVICE LOCATION</Interactive>
                          <P withoutMargin>{service.dealerName}</P>
                          <Space />
                        </div>
                        <Interactive>SERVICE DESCRIPTION</Interactive>
                        {service.completedServiceItems.map((item, i) => {
                          return (
                            <P key={i} withoutMargin>
                              {item.serviceDescription}
                            </P>
                          )
                        })}
                      </div>
                    }
                  })
                }
              />
              :
              <div className={classnames({
                [styles.MyMazdaServiceHistoryEmpty]: true
              })}>
                {emptyHistoryText ||
                  "We'll automatically keep your service records here when you complete a Mazda Genuine Service."}
              </div>
          }
          {serviceHistoryData && (
            <div className={classnames({
              [styles.MyMazdaServiceHistoryFooter]: true
            })}>
              <Button
                styleName="blackOutlined"
                href={printAllLink}
                gtm={{
                  category: "MyMazda - Servicing",
                  action: `History - Clicked "${printButtonText.toUpperCase()}"`
                }}
                external >
                {printButtonText}
              </Button>
            </div>
          )}
        </div>
      </Section>
    )
  }
}


export default MyMazdaServiceHistory



// WEBPACK FOOTER //
// ./src/AtomicContainers/MyMazdaServiceHistory/MyMazdaServiceHistory.jsx